export const url = {
  domain: "http://localhost:3000",
  // api: "http://192.168.10.52:3000",
  // api: "https://api.lumir.space", // TODO: production
  api: "http://13.124.140.212:3000",
  // api: "http://192.168.1.5:3000/",
};
